import { useEffect, useState } from 'react'

const useHotels = () => {
    const [hotels, setHotels] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const fetchData = async () => {
            const res = await fetch('https://raw.githubusercontent.com/forhad-eng/tavel-guru-hotels-data/main/data.json')
            const data = await res.json()
            setHotels(data)
            setLoading(false)
        }

        fetchData()
    }, [])

    return [hotels, loading]
}

export default useHotels